import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "signUp" }
const _hoisted_2 = { class: "signUp__iconBack" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "signUp__title" }, "Create Account", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "signUp__para auth__para--sign" }, "Free shipping, free returns, and rewards.", -1)
const _hoisted_5 = { class: "signUp__error" }
const _hoisted_6 = { class: "signUp__inputContainer" }
const _hoisted_7 = ["type"]
const _hoisted_8 = { class: "signUp__error" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<p class=\"signUp__para signUp__para--privacy\"> By creating an account, you agree to Sneakers&#39; <button class=\"signUp__accountBtn\">Privacy Policy</button> and <button class=\"signUp__accountBtn\">Terms of Use</button>. </p><div class=\"signUp__btnContainer\"><button class=\"signUp__btn\" type=\"submit\">Create Account</button></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        name: "md-keyboardarrowleft-outlined",
        class: "signUp__icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeView('LogIn'))),
        scale: "1.1"
      })
    ]),
    _createElementVNode("form", {
      class: "signUp__cta",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createAccount && _ctx.createAccount(...args)), ["prevent"]))
    }, [
      _hoisted_3,
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(_ctx.emailError.length > 0 ? 'signUp__input signUp__input--active' : 'signUp__input'),
        type: "text",
        placeholder: "Email Address",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
        autocomplete: "email"
      }, null, 2), [
        [_vModelText, _ctx.email]
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.emailError), 1),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(
            _ctx.passwordError.length > 0
              ? 'signUp__input signUp__input--active signUp__input--margin'
              : 'signUp__input signUp__input--margin'
          ),
          type: _ctx.showPassword ? 'text' : 'password',
          autocomplete: "current-password",
          placeholder: "Password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event))
        }, null, 10, _hoisted_7), [
          [_vModelDynamic, _ctx.password]
        ]),
        _createVNode(_component_v_icon, {
          onClick: _ctx.toggleShowPassword,
          class: "signUp__inputICon",
          fill: "hsl(219, 9%, 45%)",
          scale: "1.1",
          name: _ctx.showPassword ? 'bi-eye' : 'bi-eye-slash'
        }, null, 8, ["onClick", "name"])
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.passwordError), 1),
      _hoisted_9
    ], 32)
  ]))
}